import { gql } from '__generated__';

gql(`
  fragment UserFields on User {
    id
    email
    first_name
    full_name
    activated
    authenticator_enabled
  }
`);

export default gql(`
  query GetUsersForProject($project_id: ID!) {
    project(id: $project_id) {
      id
      organisation_name
      project_memberships {
        id
        permissions
        deletable
        user {
          ...UserFields
        }
      }
    }
  }
`);
